import { Component, OnInit } from '@angular/core';
import {  LoaderService } from '../../../../services'


@Component({
  selector: 'app-hotel-booking-loader',
  templateUrl: './hotel-booking-loader.component.html',
  styleUrls: ['./hotel-booking-loader.component.scss']
})
export class HotelBookingLoaderComponent implements OnInit {

  constructor(public loaderService: LoaderService,) { }

  ngOnInit(): void {
  }

}
